import type {Router, RouteLocation} from 'src/types/router';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {classify} from 'src/utils';

import {FilterCard} from './';
import Checkbox from 'src/components/lib/checkbox';

import css from './result-card.css';
import {type TranslationFunction} from 'src/types/language-support';


type Props = {
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => unknown;
  selectedTypes: string[];
  eventTypeCounts?:
    | {
        [key: string]: number;
      }
    | null
    | undefined;
  eventTypes?: {
    value: string;
    label: string;
  }[];
  history?: Router;
  location?: RouteLocation;
  sent: 'skipped_only' | 'sent_only';
};

const getFiltersSendingSkipped = (t: TranslationFunction) => [
  {
    key: 'missing_info',
    label: t('Missing_info', 'Missing info'),
    color: css.colorError,
  },
  {
    key: 'invalid_info',
    label: t('Invalid_info', 'Invalid info'),
    color: css.colorError,
  },
  {
    key: 'suppression',
    label: t('Suppression', 'Suppression'),
    color: css.colorError,
  },
  {
    key: 'other',
    label: t('Other', 'Other'),
    color: css.colorError,
  },
];

const getFiltersSent = (t: TranslationFunction) => [
  {
    key: 'delivered',
    label: t('Delivered', 'Delivered'),
  },
  {
    key: 'bounced',
    label: t('Bounced', 'Bounced'),
  },
];

const DeliveryStatusCard = ({
  onSave,
  onCancel,
  onChange,
  selectedTypes,
  sent,
}: Props) => {
  const {t} = useLabelTranslation();
  const FiltersSendingSkipped = getFiltersSendingSkipped(t);
  const FiltersSent = getFiltersSent(t);
  return (
    <FilterCard
      onSave={onSave}
      onCancel={onCancel}
      className={css.deliveryCardContainer}
    >
      {sent === 'skipped_only' ? (
        <>
          <div className={css.header}>sending skipped</div>
          <ul className={css.checklist}>
            {FiltersSendingSkipped.map(({key, label, color}) => (
              <li key={key}>
                <label
                  className={classify(css.label, {
                    [css.labelChecked]: selectedTypes.includes(key),
                  })}
                  style={{color}}
                >
                  <Checkbox
                    className={css.checkbox}
                    name={key}
                    checked={selectedTypes.includes(key)}
                    onChange={onChange}
                  />
                  {label}
                </label>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <>
          <ul className={css.checklist}>
            {FiltersSent.map(({key, label}) => (
              <li key={key}>
                <label
                  className={classify(css.label, {
                    [css.labelChecked]: selectedTypes.includes(key),
                  })}
                >
                  <Checkbox
                    className={css.checkbox}
                    name={key}
                    checked={selectedTypes.includes(key)}
                    onChange={onChange}
                  />
                  {label}
                </label>
              </li>
            ))}
          </ul>
        </>
      )}
    </FilterCard>
  );
};

export default DeliveryStatusCard;
